document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.querySelectorAll('[data-faq-page]').forEach((page) => {
  const search = page.querySelector('[data-faq-search]');
  const count = page.querySelector('[data-faq-count]');
  const empty = page.querySelector('[data-faq-empty]');
  const items = Array.from(page.querySelectorAll('[data-faq-item]'));
  const topics = Array.from(page.querySelectorAll('[data-faq-topic]'));
  let activeTopic = 'all';

  const update = () => {
    const query = search?.value.trim().toLowerCase() || '';
    let matches = 0;
    items.forEach((item) => {
      const topicMatches = activeTopic === 'all' || item.dataset.faqCategory === activeTopic;
      const copyMatches = !query || (item.dataset.faqCopy || '').toLowerCase().includes(query);
      item.hidden = !(topicMatches && copyMatches);
      if (!item.hidden) matches += 1;
    });
    if (count) count.textContent = `${matches} ${matches === 1 ? 'question' : 'questions'}`;
    if (empty) empty.hidden = matches !== 0;
  };

  topics.forEach((topic) => topic.addEventListener('click', () => {
    activeTopic = topic.dataset.faqTopic || 'all';
    topics.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === topic)));
    update();
  }));
  search?.addEventListener('input', update);
  page.querySelector('[data-faq-reset]')?.addEventListener('click', () => {
    activeTopic = 'all';
    if (search) search.value = '';
    topics.forEach((topic) => topic.setAttribute('aria-pressed', String(topic.dataset.faqTopic === 'all')));
    update();
    search?.focus();
  });
});

document.addEventListener('click', (event) => {
  document.querySelectorAll('.mobile-menu-button[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
